<template>
  <table class="listado table table-hover">
    <thead class="bg-primary text-white">
      <th-ordenado titulo="Nombre" campo="nombre" />
      <th-ordenado titulo="Unidad de negocio" campo="unidadNegocio" />
      <th-ordenado titulo="País" campo="paisId" />
      <th-ordenado titulo="Contacto" campo="contacto" />
      <th-ordenado titulo="Creado el" campo="creadoEl" />
      <th class="th-acciones">Acciones</th>
    </thead>
    <tbody>
      <sin-registros v-if="!clientes" :colspan="5" />
      <tr v-for="(cliente, idx) in clientes" :key="idx" role="button">
        <td @click="editarCliente(cliente.id)">
          {{ cliente.nombre }}
        </td>
        <td @click="editarCliente(cliente.id)">
          {{ cliente.unidadNegocio }}
        </td>
        <td @click="editarCliente(cliente.id)">
          {{ cliente.pais }}
        </td>
        <td @click="editarCliente(cliente.id)">
          {{ cliente.contacto }}
        </td>
        <td @click="editarCliente(cliente.id)">
          {{ formatDateEs(cliente.creadoEl) }}
        </td>
        <td nowrap="nowrap" class="td-acciones">
          <b-button-group size="sm">
            <b-button variant="primary" class="actionButton" :to="`/clientes/editar/${cliente.id}`">
              <v-icon name="edit" width="16" />
              <span> Editar</span>
            </b-button>
            <b-button
              :disabled="cliente.numeroOfertas == 0"
              variant="success"
              class="actionButton"
              :to="`/ofertas?clienteId=${cliente.id}`"
            >
              <v-icon name="check-square" width="16" />
              <span>
                Ofertas
                <small
                  ><b-badge pill variant="light">{{ cliente.numeroOfertas }}</b-badge></small
                ></span
              >
            </b-button>
            <b-button
              :disabled="cliente.numeroContratos == 0"
              variant="warning"
              class="actionButton"
              :to="`/contratos/cliente/${cliente.id}`"
            >
              <v-icon name="layers" width="16" />
              <span>
                Contratos
                <small
                  ><b-badge pill variant="light">{{ cliente.numeroContratos }}</b-badge></small
                ></span
              >
            </b-button>
          </b-button-group>
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { formatDateEs } from "@/services/date";
export default {
  props: {
    clientes: Array,
  },
  methods: {
    formatDateEs,
    editarCliente(clienteId) {
      this.$router.push("/clientes/editar/" + clienteId);
    },
  },
};
</script>
